const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoPricelocq(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 31.93",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SEAOIL"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M27.37,11.52A13.21,13.21,0,0,0,26.63,10L30.1,8a16.24,16.24,0,0,1,1,2.12Zm-1.75-3a12.9,12.9,0,0,0-1.15-1.29l2.77-2.86A14.77,14.77,0,0,1,28.75,6ZM23.05,6a13.76,13.76,0,0,0-1.47-.9L23.4,1.53a16.56,16.56,0,0,1,2,1.25Z",
    style: {
      fill: "#3f8edd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.48,13.52a8.81,8.81,0,1,1-10.91-6h0a8.82,8.82,0,0,1,10.91,6",
    style: {
      fill: "#3f8edd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.85,21.88l2.67,2.63A16,16,0,0,0,32,16a15.13,15.13,0,0,0-.17-2.33l-3.55.58A11.36,11.36,0,0,1,28.41,16a12.25,12.25,0,0,1-1.52,5.92",
    style: {
      fill: "#753bbd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.54,27A12.35,12.35,0,1,1,16,3.61,12.69,12.69,0,0,1,19,4L19.91.5a16,16,0,1,0,4.26,29.14Z",
    style: {
      fill: "#753bbd"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.39,
    y: 15.64,
    width: 3.59,
    height: 17.59,
    transform: "translate(-10.2 24.26) rotate(-45.01)",
    style: {
      fill: "#3f8edd"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoPricelocq);
export default __webpack_public_path__ + "static/media/logo-pricelocq.573e45fbcc29068595ff9ce2bea2b1de.svg";
export { ForwardRef as ReactComponent };